export class Link {
  public rel: string;
  public href: string;

  constructor(rel: string, href: string){
    this.rel = rel;
    this.href = href;
  }

}
